<template>
  <PageWrapper
    :isLoading="isLoading"
    hasFilters
    @submitFilters="resetPageNumberAndSubmitFilters"
  >
    <template #title>
      لیست جلسات رزرو شده
      <template v-if="userFullName"> کاربر {{ userFullName }} </template>
      <template v-else> کاربران شما </template>
    </template>
    <template #filters>
      <SearchInput
        inputId="studentFullname"
        inputLabel="جستجوی نام زبان آموز"
        inputPlaceholder="نام کاربر"
        :inputValue="scheduleListFilters.studentFullname"
        v-model="scheduleListFilters.studentFullname"
        @enter="resetPageNumberAndSubmitFilters"
      ></SearchInput>
      <SearchInput
        inputId="studentMobile"
        inputLabel="جستجوی شماره زبان آموز"
        inputPlaceholder="شماره کاربر"
        :inputValue="scheduleListFilters.studentMobile"
        v-model="scheduleListFilters.studentMobile"
        @enter="resetPageNumberAndSubmitFilters"
      ></SearchInput>
      <SearchInput
        inputId="studentEmail"
        inputLabel="جستجوی ایمیل زبان آموز"
        inputPlaceholder="ایمیل کاربر"
        :inputValue="scheduleListFilters.studentEmail"
        v-model="scheduleListFilters.studentEmail"
        @enter="resetPageNumberAndSubmitFilters"
      ></SearchInput>
      <SearchInput
        inputId="descriptionFilter"
        inputLabel="توضیحات تراکنش"
        inputPlaceholder="توضیحات تراکنش"
        :inputValue="scheduleListFilters.description"
        v-model="scheduleListFilters.description"
        @enter="resetPageNumberAndSubmitFilters"
      ></SearchInput>
      <RangeDatePicker
        class="w-24 filters-width"
        inputId="startRangeDate"
        label="بازه‌ی تاریخ شروع جلسه"
        @getDateRange="setStartRangeDate"
      ></RangeDatePicker>
      <RangeDatePicker
        class="w-24 filters-width"
        inputId="createRangeDate"
        label="بازه‌ی تاریخ رزرو جلسه"
        @getDateRange="setCreateRangeDate"
      ></RangeDatePicker>
      <MasterPicker
        v-if="isForAdmin"
        class="w-24 filters-width"
        @getMaster="setMaster"
      ></MasterPicker>
      <PriceCategoryPicker
        class="w-24 filters-width"
        @getPriceCategory="setPriceCategory"
      ></PriceCategoryPicker>
      <CustomSelect
        class="w-24 filters-width"
        inputLabel="فیلتر VIP"
        :customOptions="isVipOptions"
        v-model="scheduleListFilters.isVip"
      ></CustomSelect>
    </template>
    <div
      class="w-100 d-flex justify-content-end mb-1"
      v-if="$can('DeleteSchedulesForAdmin', 'Schedule')"
    >
      <BButton
        variant="danger"
        :disabled="selectedScheduleIdsForDelete.length > 0 ? false : true"
        @click="renderDeleteConfirmationModal"
      >
        حذف گروهی
      </BButton>
    </div>
    <CustomTable
      v-if="schedulesList"
      :pageNumber="scheduleListFilters.pageNumber"
      :count="scheduleListFilters.count"
      :totalCount="totalCount"
      :tableColumns="tableColumns"
      :tableItems="schedulesList"
      @changePage="changePage"
    >
      <template #studentFullname="data">
        <b-link
          :to="
            isForAdmin
              ? `/users/${data.item.studentUserId}`
              : `/master/users/${data.item.studentUserId}`
          "
        >
          {{ data.item.studentFullname }}
        </b-link>
      </template>
      <template #startDate="data">
        {{ new Date(data.item.startDate).toLocaleDateString("fa-IR") }}
        -
        {{
          new Date(data.item.startDate).toLocaleTimeString("fa-IR", {
            hour: "2-digit",
            minute: "2-digit",
          })
        }}
      </template>
      <template #actions="data">
        <template v-if="$can('DeleteSchedulesForAdmin', 'Schedule')">
          <BFormCheckbox
            v-if="$can('DeleteSchedulesForAdmin', 'Schedule')"
            name="isRequiredSwitch"
            switch
            plain
            v-model="selectedScheduleIdsForDelete"
            :value="data.item.id"
            variant="danger"
          >
            <small style="margin-right: 3px"> انتخاب برای حذف </small>
          </BFormCheckbox>
          <!-- <BButton
            v-if="$can('DeleteSchedulesForAdmin', 'Schedule')"
            type="button"
            variant="transparent"
            size="sm"
            @click="renderDeleteConfirmationModal(data.item)"
          >
            <FeatherIcon icon="Trash2Icon" class="text-danger" size="20" />
          </BButton> -->
          <span v-else>-</span>
        </template>
        <template v-else>
          <b-link
            :to="`/master/users/${data.item.studentUserId}/${data.item.priceCategory}`"
            class="text-primary"
          >
            <FeatherIcon size="20" icon="ExternalLinkIcon" />
          </b-link>
        </template>
      </template>
    </CustomTable>
    <DeleteScheduleConfirmationModal
      :selectedSchedulesLength="selectedScheduleIdsForDelete.length"
      @getSecondConfirmation="getSecondDeleteConfirmation"
      :isLoading="isLoading"
    ></DeleteScheduleConfirmationModal>
    <SecondDeleteScheduleConfirmationModal
      @deleteSchedule="deleteReservedSchedule"
    ></SecondDeleteScheduleConfirmationModal>
  </PageWrapper>
</template>

<script>
export default {
  props: {
    userFullName: {
      type: [String, null],
      required: false,
      default: null,
    },
    userIdFilter: {
      type: [String, Number, null],
      required: false,
      default: null,
    },
    isForAdmin: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  watch: {
    userIdFilter: {
      immediate: true,
      handler(val) {
        this.scheduleListFilters.studentUserId = val;
      },
    },
  },
  mounted() {
    if (this.computedPageRouteQuery) {
      this.scheduleListFilters.pageNumber = this.computedPageRouteQuery;
    } else {
      this.scheduleListFilters.pageNumber = 1;
    }
    this.getScheduleList();
  },
  data() {
    return {
      isLoading: false,
      scheduleListFilters: {
        pageNumber: 1,
        count: 10,
        studentUserId: null,
        masterUserId: null,
        startDate: null,
        endDate: null,
        startCreateDate: null,
        endCreateDate: null,
        priceCategory: null,
        isVip: null,
        studentMobile: null,
        studentFullname: null,
        studentEmail: null,
        masterMobile: null,
        masterFullname: null,
      },
      isVipOptions: [
        {
          value: null,
          text: "همه",
        },
        {
          value: true,
          text: "دارای VIP",
        },
        {
          value: false,
          text: "بدون VIP",
        },
      ],
      tableColumns: [
        {
          key: "studentFullname",
          label: "نام زبان آموز",
        },
        {
          key: "studentMobile",
          label: "شماره زبان آموز",
        },
        {
          key: "masterFullname",
          label: "نام استاد",
        },
        {
          key: "masterMobile",
          label: "شماره استاد",
        },
        {
          key: "priceCategoryTitle",
          label: "گروه‌بندی",
        },
        {
          key: "startDate",
          label: "تاریخ شروع جلسه",
        },
        {
          key: "actions",
          label: "جزئیات",
        },
      ],
      schedulesList: null,
      totalCount: null,
      tempSchedule: null,
      selectedScheduleIdsForDelete: [],
    };
  },
  methods: {
    changePage(pageNumber) {
      this.scheduleListFilters.pageNumber = pageNumber;
      this.setPageNumberQuery(pageNumber);
      this.getScheduleList();
    },
    async deleteReservedSchedule() {
      if (!this.isLoading) {
        try {
          this.isLoading = true;
          let _this = this;
          let deleteSchedulesForAdmin = new DeleteSchedulesForAdmin(_this);
          deleteSchedulesForAdmin.setRequestParamDataObj(
            _this.selectedScheduleIdsForDelete
          );
          await deleteSchedulesForAdmin.fetch((res) => {
            if (res.isSuccess) {
              _this.$toast({
                component: ToastificationContent,
                props: {
                  title: "حذف شد!",
                  icon: "EditIcon",
                  variant: "success",
                  text: "جلسه رزرو شده با موفقیت حذف شد!",
                },
              });

              _this.hideConfirmationModals();
              _this.tempSchedule = null;
              _this.getScheduleList();
            } else {
              _this.$toast({
                component: ToastificationContent,
                props: {
                  title: "ویرایش نشد!",
                  icon: "XIcon",
                  variant: "danger",
                  text: res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
                },
              });
            }
          });
        } catch (error) {
          console.error(error);
        } finally {
          this.isLoading = false;
        }
      }
    },
    resetPageNumberAndSubmitFilters() {
      this.changePage(1);
    },
    setPageNumberQuery(pageNumber) {
      this.$router.replace({
        path: this.$route.path,
        query: {
          page: pageNumber,
        },
      });
    },
    getSecondDeleteConfirmation() {
      this.$bvModal.show("delete-reserved-schedule-confirmation-second");
    },
    hideConfirmationModals() {
      this.$bvModal.hide("delete-reserved-schedule-confirmation");
      this.$bvModal.hide("delete-reserved-schedule-confirmation-second");
    },
    renderDeleteConfirmationModal() {
      this.$bvModal.show("delete-reserved-schedule-confirmation");
    },

    setPriceCategory(priceCategoryId) {
      this.scheduleListFilters.priceCategory = priceCategoryId;
    },
    setMaster(master) {
      this.scheduleListFilters.masterUserId = master ? master.userId : null;
    },
    setIsVipFilter(vipValue) {
      this.scheduleListFilters.isVip = vipValue;
    },
    setStartRangeDate(dateRange) {
      if (dateRange && dateRange.length > 0) {
        this.scheduleListFilters.startDate = new Date(
          dateRange[0]
        ).toISOString();
        this.scheduleListFilters.endDate = new Date(dateRange[1]).toISOString();
      } else {
        this.scheduleListFilters.startDate = null;
        this.scheduleListFilters.endDate = null;
      }
    },
    setCreateRangeDate(dateRange) {
      if (dateRange && dateRange.length > 0) {
        this.scheduleListFilters.startCreateDate = new Date(
          dateRange[0]
        ).toISOString();
        this.scheduleListFilters.endCreateDate = new Date(
          dateRange[1]
        ).toISOString();
      } else {
        this.scheduleListFilters.startCreateDate = null;
        this.scheduleListFilters.endCreateDate = null;
      }
    },
    async getScheduleList() {
      try {
        this.isLoading = true;
        let _this = this;

        let getScheduleList = null;
        if (this.isForAdmin) {
          getScheduleList = new GetScheduleListForAdmin(_this);
        } else {
          getScheduleList = new GetScheduleListForMaster(_this);
        }
        getScheduleList.setRequestParamDataObj(_this.scheduleListFilters);
        await getScheduleList.fetch((res) => {
          _this.totalCount = res.total;
          _this.schedulesList = res.data;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  computed: {
    computedPageRouteQuery() {
      if (this.$route.query && this.$route.query.page) {
        return this.$route.query.page;
      }
      return null;
    },
  },
  components: {
    BButton,
    BLink,
    FiltersWrapper,
    SearchInput,
    MasterPicker,
    RangeDatePicker,
    PriceCategoryPicker,
    CustomSelect,
    DeleteScheduleConfirmationModal,
    SecondDeleteScheduleConfirmationModal,
    PageWrapper,
    CustomTable,
    BFormCheckbox,
  },
};
import FiltersWrapper from "@/views/components/Utils/FiltersWrapper.vue";
import SearchInput from "@/views/components/Utils/SearchInput.vue";
import RangeDatePicker from "@/views/components/Utils/RangeDatePicker.vue";
import MasterPicker from "@/views/components/MasterActiveCourse/MasterPicker.vue";
import PriceCategoryPicker from "@/views/apps/PriceCategory/PriceCategoryPicker.vue";
import CustomSelect from "@/views/components/Utils/CustomSelect.vue";
import DeleteScheduleConfirmationModal from "@/views/components/Schedule/DeleteScheduleConfirmationModal.vue";
import SecondDeleteScheduleConfirmationModal from "@/views/components/Schedule/SecondDeleteScheduleConfirmationModal.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import CustomTable from "@/views/components/Utils/CustomTable.vue";
import {
  GetScheduleListForAdmin,
  GetScheduleListForMaster,
  DeleteSchedulesForAdmin,
} from "@/libs/Api/Schedules";
import { BLink, BButton, BFormCheckbox } from "bootstrap-vue";
</script>
